import * as React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { IReport } from '../../../common/sharedTypes';

interface CompletedIndicatorProps {
  hasMergedDriverReport?: boolean;
}

function DriverReportMergedIndicator({ hasMergedDriverReport }: CompletedIndicatorProps) {
  return (
    <>{' '}
      {hasMergedDriverReport &&
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip
              id='tooltip-merged-indicator-top'
            >
              Contains a Merged Driver Report
            </Tooltip>
          }
        >
          <i className="fa-solid fa-car"></i>
        </OverlayTrigger>
      }
    </>
  )
}

export default DriverReportMergedIndicator;